import LocalGasStation from '@mui/icons-material/LocalGasStation';
import { Collapse } from '@mui/material';
import { AutocompleteArrayInput, FilterList, ReferenceArrayInput, SelectArrayInput, useTranslate } from 'react-admin';
import { filterToQuery } from '../../utils';
import useDashboardContext from '../../hooks/useDashboardContext';

const DashboardStationInput = ({ isOpen }) => {
  const translate = useTranslate();
  const { setStationIds } = useDashboardContext();

  return (
    <>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <FilterList
          label="Postos"
          icon={<LocalGasStation titleAccess="Postos" />}
        />
      </Collapse>
      <ReferenceArrayInput
        source="stationIds"
        reference="stations"
        perPage={null}
        sort={{ field: "name", order: "ASC" }}
      >
        <AutocompleteArrayInput
          filterToQuery={filterToQuery}
          sx={{ width: 160, padding: 0 }}
          onChange={(value) => setStationIds(value ?? [])}
          label={!isOpen && 'Postos'}
          optionText="name"
          noOptionsText={translate('ra.input.autocomplete.no_options_text')}
        />
      </ReferenceArrayInput>
    </>);
}

export default DashboardStationInput;
